import { API_BASE_URL } from '../config/apiBaseUrl';

const API_URL = API_BASE_URL;

/** Turn API-relative upload paths into absolute URLs for <img src>. */
export function resolveMediaUrl(url: string | undefined | null): string {
  const raw = String(url ?? '').trim();
  if (!raw) return '';
  if (/^https?:\/\//i.test(raw) || raw.startsWith('data:') || raw.startsWith('blob:')) {
    return raw;
  }
  if (raw.startsWith('//')) {
    return `${window.location.protocol}${raw}`;
  }
  const path = raw.startsWith('/') ? raw : `/${raw}`;
  return `${API_URL}${path}`;
}
